import { adminUrlBuilder } from '@app/api/utils';

export class ReportsApi {
  static readonly path = 'reports';

  /**
   * Download the appointment audit ledger as an XLSX file for a tax inspection.
   * Optional from/to are yyyy-MM-dd.
   */
  static async exportAuditLog(from?: string, to?: string): Promise<Blob> {
    const queryParams: Record<string, string> = {};
    if (from) queryParams.from = from;
    if (to) queryParams.to = to;

    const url = adminUrlBuilder(queryParams, `${ReportsApi.path}/audit-log/export`);
    const response = await fetch(url, { method: 'get' });
    if (!response.ok) throw 'Failed to export audit log';

    return await response.blob();
  }

  /**
   * Download all appointments in a date range as an XLSX file (current state,
   * no change history). Optional from/to are yyyy-MM-dd.
   */
  static async exportAppointments(from?: string, to?: string): Promise<Blob> {
    const queryParams: Record<string, string> = {};
    if (from) queryParams.from = from;
    if (to) queryParams.to = to;

    const url = adminUrlBuilder(queryParams, `${ReportsApi.path}/appointments/export`);
    const response = await fetch(url, { method: 'get' });
    if (!response.ok) throw 'Failed to export appointments';

    return await response.blob();
  }

  /**
   * "מבנה אחיד" files for an IRS inspection: ZIP with INI.TXT + BKMVDATA.TXT
   * per tax year since the business started.
   *
   * Small exports return the ZIP Blob directly; large ones are built in the
   * background and emailed — then `{queued, email}` is returned instead.
   */
  static async exportIrsInspection(
    taxId?: string,
  ): Promise<Blob | { queued: boolean; email: string }> {
    const url = adminUrlBuilder({}, `${ReportsApi.path}/irs-inspection/export`);
    const response = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(taxId ? { taxId } : {}),
    });
    if (!response.ok) {
      if (response.status === 404) throw { status: 404 };
      let message = 'Failed to export IRS inspection files';
      try {
        message = (await response.json())?.message ?? message;
      } catch { /* keep default */ }
      throw { status: response.status, message };
    }
    if (response.headers.get('content-type')?.includes('application/json')) {
      return await response.json();
    }
    return await response.blob();
  }
}
